import React, { createContext, useContext, useState } from "react";

const RegisterContext = createContext();

const INITIAL_STATE = {
  // Step 1
  email: "",
  password: "",
  token: "",
  organization_id: null,
  // Step 2
  firstName: "",
  lastName: "",
  labName: "",
  country: "",
  labType: "Dental",
};

export function RegisterProvider({ children }) {
  const [registerData, setRegisterData] = useState(INITIAL_STATE);

  const updateRegisterData = (fields) => {
    setRegisterData((prev) => ({ ...prev, ...fields }));
  };

  const resetRegisterData = () => {
    setRegisterData(INITIAL_STATE);
  };

  return (
    <RegisterContext.Provider value={{ registerData, updateRegisterData, resetRegisterData }}>
      {children}
    </RegisterContext.Provider>
  );
}

export function useRegister() {
  return useContext(RegisterContext);
}